"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgCoax(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M3 10a7 7 0 017-7h20a7 7 0 017 7v20a7 7 0 01-7 7H10a7 7 0 01-7-7V10z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M28.5 25a4.5 4.5 0 100-9 4.5 4.5 0 000 9z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.5 21a.5.5 0 110-1 .5.5 0 010 1z", fill: "currentColor", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M11.5 25a4.5 4.5 0 100-9 4.5 4.5 0 000 9z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M11.5 22a1.5 1.5 0 100-3 1.5 1.5 0 000 3z", stroke: "currentColor", strokeWidth: 1.2 }, void 0)] }), void 0));
}
exports.default = SvgCoax;
//# sourceMappingURL=Coax.js.map